// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { API_BASE } from './api-base';

export const environment = {
  production: false,
  /** Local/dev: path URLs (`/login`). Set true only if the host cannot SPA-fallback deep links. */
  useHashRouting: false,
  /** When true and CefSharp is missing (normal Chrome/Edge), ToughKey APIs use in-memory mocks for local UI testing only. Disabled in production builds. */
  toughKeyBrowserMock: true,
  /**
   * Dev only: if Toughbrowser exposes `window.CefSharp` but the user-agent is not Lokblok-shaped,
   * set this to `true` so `BindObjectAsync('toughKey')` still runs. Keep `false` in normal Lokblok builds.
   */
  toughKeyTrustCefSharpHost: false,
  /**
   * Legacy sync window.confirm callbacks. Keep false when toughKeyUseVisibleInitModals is true
   * (matches test-secure-terminal-demo.html async modal flow in Toughbrowser).
   */
  toughKeyUseSyncCallbacks: false,
  /**
   * Step 2 in Toughbrowser: same visible OK/Cancel modals as test-secure-terminal-demo.html.
   */
  toughKeyUseVisibleInitModals: true,
  /**
   * Optional overrides for initializeToughkeyAdmin Step 2 JSON.
   * Ask Lokblok for production bfsvcpublickey x/y — demo values are placeholders.
   */
  toughKeyAdminInit: undefined as
    | {
        org?: string;
        grp?: string;
        usr?: string;
        friendlyname?: string;
        bfsvcPublicKeyX?: string;
        bfsvcPublicKeyY?: string;
      }
    | undefined,
  /** Marketing / download info for Lokblok (Toughbrowser). */
  lokblokWebsiteUrl: 'https://www.lokblok.co',
  /**
   * Optional. Full path to Toughbrowser.exe for “Copy PowerShell launch” on the delegation dashboard.
   * Web apps cannot start .exe files; the button copies a Start-Process line for Windows PowerShell.
   */
  toughbrowserWindowsExe: '',
  /** My Legacy Electron local HTTP (main.js) — must match client port. */
  delegationClientAppStatusUrl: 'http://localhost:3000/getappStatus',
  /** ToughKey get-status endpoint — device serial / PIN state (toughkeysdk.md). */
  delegationClientToughkeyDeviceUrl: 'http://localhost:3000/getToughkeyDevice',
  /** USB GetAdmin public key for admin credential verify (Step 2b). */
  delegationClientRecoveryAdminPublicUrl: 'http://localhost:3000/getRecoveryAdminPublic',
  /**
   * Dev-only Step 2b fallback when Toughbrowser cannot read USB serial.
   * Disabled — My Legacy reads serial from USB via getToughkeyDevice after /navigate.
   * To re-enable for local debugging only: delegationAdminToughkeySerialFallback: 'your-serial-here'
   */
  // delegationAdminToughkeySerialFallback: 'e88104536981446b',
  delegationAdminToughkeySerialFallback: '',
  /** Not used — ML path signs inner tid-dlg with admin Toughkey only (no clocr.com provider wrap). */
  delegationProviderJwtIssuer: '',
  /**
   * Permanent Test 22: Scytale list JWT → Toughkey admin sign → POST tid-auth.
   * ML needs 3 nested signatures: tid-auth → Scytale → tid-dlg.
   */
  delegationTest22AdminSignInput: 'scytale-jwt' as
    | 'provider-rec'
    | 'inner-tid-dlg'
    | 'scytale-jwt',
  /** API base URL: set per build in api-base.ts / api-base.live.ts. */
  base: API_BASE,
  s3: "https://s3.amazonaws.com/",
  clientAppUrl : "https://s3.amazonaws.com/clocrdev/msi/CryptoLegacy.msi",
  macClientAppUrl : "https://s3.amazonaws.com/clocrdev/mac/CryptoLegacy.dmg",
  macClientAppUrlx64 : "https://s3.amazonaws.com/clocrdev/mac/x64/CryptoLegacy.dmg",
  get_front_end_clientId : "8b5a40e4-3537-4899-aa94-08db18ea2a62",
  clientBaseUrl: "https://dev.my-legacy.ai/", // Local development - change back to "https://dev.my-legacy.ai/" for dev server
  // clientBaseUrl: "https://dev.my-legacy.ai/", // Dev server
  /** Advisor referral signup URL base (referralCode prefix sent to register API). */
  referralSignupBaseUrl: 'https://dev.my-legacy.ai',
  /** Silver plan promo codes for advisor referral signup links. */
  advisorReferralPromoCodes: {
    monthly: 'CSFSILVERMO',
    yearly: 'CSFSILVERYR',
  },
  businessDbName: "clocrus",
  /** Pin Secure Shell version gate until backend publishes this build (dev / pre-API). */
  secureShellClientVersion: '2.1.4',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
